// Componentes del módulo de configuración
const Principal = () => import('@/components/configs/backend/Principal.vue');
const SalesPoint = () => import('@/components/configs/backend/Puntos-de-venta.vue');
const Rules = () => import('@/components/configs/backend/Rules.vue');
const Users = () => import('@/components/configs/backend/Users.vue');
const Roles = () => import('@/components/configs/backend/Roles.vue');
const Cards = () => import('@/components/configs/Tarjetas.vue');
const Ecommerce = () => import('@/components/configs/Ecommerce.vue');
const PdfTemplates = () => import('@/components/configs/PdfTemplates.vue');
const IndexConfiguracion = () => import('@/components/configs/Index-configuracion.vue');

const config = {
  path: '/configuracion',
  children: [
    {
      // La sección no tenía índice: se entraba directo a una de las nueve
      // pantallas y las otras no se podían encontrar.
      path: '',
      name: 'Configuración',
      component: IndexConfiguracion,
      meta: { title: 'Configuración' },
    },
    {
      path: 'principal',
      name: 'Principal',
      component: Principal,
    },
    {
      path: 'puntos-de-venta',
      name: 'Puntos de venta',
      component: SalesPoint,
    },
    {
      path: 'tarjetas',
      name: 'Tarjetas',
      component: Cards,
    },
    {
      path: 'promociones',
      name: 'Promociones',
      component: Rules,
    },
    {
      path: 'usuarios',
      name: 'Usuarios del sistema',
      component: Users,
    },
    {
      path: 'roles',
      name: 'Roles y permisos',
      component: Roles,
    },
    {
      path: 'ecommerce',
      name: 'E-commerce',
      component: Ecommerce,
    },
    {
      path: 'plantillas-pdf',
      name: 'Plantillas PDF',
      component: PdfTemplates,
    },
  ],
};

export default config;
